import { WEEKDAY_SHORT, weekdayOf } from '@shh/shared';
import { dateFormat, locale } from '../../lib/locale';

/** Dates as the calendar writes them, in the device language (UTC noon: no time-zone slips). */
const at = (date: string) => new Date(`${date}T12:00:00Z`);
const fmt = (opts: Intl.DateTimeFormatOptions) => dateFormat({ ...opts, timeZone: 'UTC' });

export const monthTitle = (date: string) =>
  fmt({ month: 'long', year: 'numeric' }).format(at(date));
export const monthName = (date: string) => fmt({ month: 'long' }).format(at(date));
export const dayTitle = (date: string) =>
  fmt({ weekday: 'long', day: 'numeric', month: 'long' }).format(at(date));
export const dayShort = (date: string) =>
  fmt({ weekday: 'short', day: 'numeric', month: 'short' }).format(at(date));
export const weekdayShort = (date: string) => WEEKDAY_SHORT[locale][weekdayOf(date) - 1]!;
export const dayNumber = (date: string) => Number(date.slice(8));

/** "19.–25. Okt." / "29. Okt. – 4. Nov." */
export function rangeText(from: string, to: string): string {
  const short = fmt({ day: 'numeric', month: 'short' });
  if (from.slice(0, 7) === to.slice(0, 7)) {
    return `${fmt({ day: 'numeric' }).format(at(from))}–${short.format(at(to))}`;
  }
  return `${short.format(at(from))} – ${short.format(at(to))}`;
}

/** "Mo., 2. Nov." – fits the calendar bar on phones. */
export const dayTitleShort = (date: string) =>
  fmt({ weekday: 'short', day: 'numeric', month: 'short' }).format(at(date));
